<div class="table-container">
  <table class="table-container__table">
    <thead>
      <tr>
        <th class="table-container__col-periodicidade-compra" rowspan="3">
          Periodicidade de Compra
        </th>
        <th
          class="table-container__col-quantidade-meses-sem-faturamento"
          colspan="4"
        >
          Quantidade de meses sem faturamento
        </th>
      </tr>
      <tr>
        <th class="table-container__col-situacao">Positivo</th>
        <th class="table-container__col-situacao">Ativo</th>
        <th class="table-container__col-situacao">Pré-Inativo</th>
        <th class="table-container__col-situacao">Inativo</th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let periodicidadeCompra of periodicidadesCompras"
        [class.table-container--periodicidade-atual]="
          periodicidadeCompra?.id === lineInFocus
        "
      >
        <td class="table-container__col-periodicidade-compra">
          {{ periodicidadeCompra.nome }}
        </td>
        <td class="table-container__col-situacao">0</td>
        <td class="table-container__col-situacao">
          {{
            periodicidadeCompra.clienteCarteiraQuantidadeMesesPreinativar - 1
          }}
        </td>
        <td class="table-container__col-situacao">
          {{ periodicidadeCompra.clienteCarteiraQuantidadeMesesPreinativar }}
        </td>
        <td class="table-container__col-situacao">
          {{ periodicidadeCompra.clienteCarteiraQuantidadeMesesInativar }}/+
        </td>
      </tr>
    </tbody>
  </table>
</div>
